<template>
  <div
    class="mx-auto Kanit"
    style="
      display: flex;
      flex-flow: column;
      position: absolute;
      height: 100%;
      max-width: 500px;
    "
  >
    <div
      class="pa-4 text-center white--text Kanit"
      style="font-size: 22px; background-color: #002969"
    >
      การให้ความยินยอมในการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล
    </div>

    <v-card
      class="ma-4 pa-3"
      style="overflow-y: scroll; font-size: 15px"
      color="#eee"
    >
      <div class="Kanit">
        <p>บริษัท วาย เอ เซลส์ แอนด์ เซอวิสเซส จำกัด ให้ความสำคัญกับการเก็บรวบรวมและรักษาความปลอดภัยของข้อมูลส่วนบุคคลของท่านไว้เป็นความลับ บริษัทจึงขอความยินยอมจากท่านเพื่อการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านที่ได้ให้ไว้แก่บริษัท มีรายละเอียด ดังนี้</p>
        <div style="text-decoration: underline; font-weight: 600; margin-bottom: 8px;">ข้อมูลส่วนบุคคลของท่านที่บริษัทเก็บรวบรวม</div>
        <div style="font-weight: 600; margin-bottom: 4px;">1. ข้อมูลส่วนบุคคลทั่วไป</div>
        <ul style="margin-bottom: 16px;">
          <li>ชื่อ - นามสกุล</li>
          <li>หมายเลขบัตรประจำตัวประชาชน</li>
          <li>หมายเลขโทรศัพท์</li>
          <li>ที่อยู่</li>
          <li>E-mail</li>
          <li>หมายเลขบัญชีธนาคาร</li>
          <li>รหัสสากลประจำอุปกรณ์เคลื่อนที่ (IEMI)</li>
        </ul>
        <div style="font-weight: 600; margin-bottom: 4px;">2. ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Personal Data)</div>
        <p>เพื่อความเป็นส่วนตัวของท่าน บริษัทมีนโยบายไม่เก็บรวบรวมข้อมูลส่วนบุคคลที่มีความอ่อนไหว เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ ข้อมูลพันธุกรรม ข้อมูลชีวภาพ หรือข้อมูลอื่นใดที่กระทบต่อท่านในฐานะเจ้าของข้อมูลส่วนบุคคลในลักษณะเดียวกัน</p>
        <div style="text-decoration: underline; font-weight: 600; margin-bottom: 8px;">วัตถุประสงค์ในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน</div>
        <p>บริษัทประสงค์จะเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่านตามวัตถุประสงค์ดังต่อไปนี้</p>
        <ol style="margin-bottom: 16px;">
          <li>เก็บรวบรวมเป็นฐานข้อมูลทางการตลาดของบริษัท</li>
          <li>เก็บรวบรวมและประมวลผลเพื่อดำเนินกิจกรรมทางการตลาด</li>
          <li>ประชาสัมพันธ์และเสนอขายสินค้าหรือบริการต่างๆ ตามที่บริษัทเห็นสมควร</li>
          <li>เปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บริษัทในเครือ เพื่อประชาสัมพันธ์และเสนอขายสินค้าหรือบริการต่างๆ ของบริษัทในเครือ</li>
        </ol>
        <p><span style="text-decoration: underline; font-weight: 600;">ระยะเวลาการเก็บข้อมูล:</span> บริษัทจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไม่เกินระยะเวลาเท่าที่จำเป็นหรือระยะเวลาตามกฎหมายสำหรับวัตถุประสงค์ที่บริษัทกำหนดเท่านั้น</p>
        <div style="text-decoration: underline; font-weight: 600; margin-bottom: 8px;">สิทธิของท่านเมื่อให้ความยินยอม</div>
        <p>ในเวลาใดก็ตาม ท่านมีสิทธิดังต่อไปนี้เกี่ยวกับข้อมูลส่วนบุคคลของท่าน</p>
        <ul style="margin-bottom: 12px;">
          <li>ท่านมีสิทธิเข้าถึงข้อมูลส่วนบุคคลของท่านที่บริษัทรวบรวม</li>
          <li>ท่านมีสิทธิขอให้แก้ไขข้อมูลให้ถูกต้องหรือเพิ่มเติมข้อมูลของท่านครบถ้วน</li>
          <li>ท่านมีสิทธิขอให้ลบหรือทำลายข้อมูลส่วนบุคคลของท่าน</li>
          <li>ท่านมีสิทธิขอให้บริษัทระงับการใช้ข้อมูลส่วนบุคคลของท่าน</li>
          <li>ท่านมีสิทธิขอให้บริษัทโอนหรือส่งข้อมูลส่วนบุคคลของท่านไปยังผู้อื่น</li>
          <li>ท่านมีสิทธิคัดค้านการใช้ รวบรวม จัดเก็บ หรือเปิดเผยข้อมูลส่วนบุคคลของบริษัทในกรณีที่พบว่าบริษัททำไปเพื่อวัตถุประสงค์อื่นนอกจากที่ได้ให้ความยินยอมไว้</li>
          <li>ท่านมีสิทธิขอเพิกถอนความยินยอมที่ท่านได้ให้ไว้เมื่อใดก็ได้</li>
        </ul>
        ทั้งนี้ เป็นไปตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล และนโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท โดยท่านสามารถติดต่อสอบถามหรือแจ้งความประสงค์ตามสิทธิของท่านได้ตลอดเวลา ผ่านช่องทางตามรายละเอียดดังต่อไปนี้
      </div>
      <v-row>
        <v-col cols="3">ชื่อ</v-col>
        <v-col cols="9">customers support</v-col>
        <v-col cols="3">ที่อยู่</v-col>
        <v-col cols="9">499 ถนนกำแพงเพชร 6 แขวงลาดยาว เขตจตุจักร กรุงเทพมหานคร 10900</v-col>
        <v-col cols="3">เบอร์โทรศัพท์</v-col>
        <v-col cols="9">02-0165758</v-col>
        <v-col cols="3">E-mail</v-col>
        <v-col cols="9">contact@yasservices.co.th</v-col>
      </v-row>
      <div>
        <v-checkbox
          style="font-weight: 600"
          label="ข้าพเจ้าได้อ่านและยินยอมให้เปิดเผยข้อมูลส่วนบุคคล"
          v-model="cbagree"
        ></v-checkbox>
      </div>
    </v-card>

    <div class="pa-5 mb-3 pt-0">
      <v-btn
        @click="submitpdpa"
        :loading="saveloading"
        style="font-size: 22px"
        class="text-capitalize"
        color="primary"
        :dark="cbagree"
        :disabled="!cbagree"
        block
        >ตกลง</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      saveloading: false,
      cbagree: false,
    };
  },
  mounted() {},
  methods: {
    submitpdpa() {
      this.$emit("onAgree");
    },
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
</style>